var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancellationPercentage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#4F8701",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_2083",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H35V35H13V13Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_2083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8438 34.1406H18.1562C15.7831 34.1406 13.8594 32.2169 13.8594 29.8438V18.1562C13.8594 15.7831 15.7831 13.8594 18.1562 13.8594H29.8438C32.2169 13.8594 34.1406 15.7831 34.1406 18.1562V29.8438C34.1406 32.2169 32.2169 34.1406 29.8438 34.1406Z",
    stroke: "#4F8701",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5078 28.3398L26.5781 19.6172",
    stroke: "#4F8701",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8945 20.5195C21.8945 21.4688 21.125 22.2383 20.1758 22.2383C19.2266 22.2383 18.457 21.4688 18.457 20.5195C18.457 19.5703 19.2266 18.8008 20.1758 18.8008C21.125 18.8008 21.8945 19.5703 21.8945 20.5195Z",
    stroke: "#4F8701",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1484 27.4375C26.1484 26.4882 26.918 25.7187 27.8672 25.7187C28.8164 25.7187 29.5859 26.4882 29.5859 27.4375C29.5859 28.3868 28.8164 29.1562 27.8672 29.1562C26.918 29.1562 26.1484 28.3868 26.1484 27.4375Z",
    stroke: "#4F8701",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellationPercentage);
export default __webpack_public_path__ + "static/media/Cancellation Percentage.53250434edb780285725e7b3ada9c4f5.svg";
export { ForwardRef as ReactComponent };